module.exports = __webpack_public_path__ + "static/media/roboto-mono-v5-latin-regular.e92cc0fb.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/roboto-mono/roboto-mono-v5-latin-regular.woff2
// module id = 479
// module chunks = 0